import { memo } from 'react';

import { useTicketingOptions } from '../../store';

import SlotIncluder from '@shared/SlotIncluder';

const Slot = () => {
  const {
    options: { slotLibrary },
  } = useTicketingOptions();

  if (!slotLibrary) {
    return null;
  }

  return <SlotIncluder path={slotLibrary} />;
};

export default memo(Slot);
